/**
 * Quick Add Popup for Product Cards
 * Amber Style - Opens popup when clicking Add to Cart button
 * Uses event delegation to work with dynamically loaded content
 */

(function () {
    // Event delegation for open popup - works with dynamically loaded content
    document.addEventListener('click', function (e) {
        // Check if clicked element or its parent has the data attribute
        const openButton = e.target.closest('[data-quick-add-open]');
        if (openButton) {
            e.preventDefault();
            e.stopPropagation();

            const productId = openButton.getAttribute('data-quick-add-open');
            const popup = document.getElementById('quick-add-popup-' + productId);

            if (popup) {
                popup.setAttribute('aria-hidden', 'false');
                popup.classList.add('is-open');
                document.body.style.overflow = 'hidden';

                // Focus on the popup content for accessibility
                const content = popup.querySelector('.quick-add-popup__content');
                if (content) {
                    setTimeout(function () {
                        content.focus();
                    }, 100);
                }
            }
            return;
        }

        // Check for close button click
        const closeButton = e.target.closest('[data-quick-add-close]');
        if (closeButton) {
            e.preventDefault();

            const productId = closeButton.getAttribute('data-quick-add-close');
            const popup = document.getElementById('quick-add-popup-' + productId);

            if (popup) {
                popup.setAttribute('aria-hidden', 'true');
                popup.classList.remove('is-open');
                document.body.style.overflow = '';
            }
            return;
        }

        // Check for quantity up button
        const qtyUpButton = e.target.closest('.quick-add-popup__qty-up');
        if (qtyUpButton) {
            e.preventDefault();
            const controls = qtyUpButton.closest('.quick-add-popup__qty-controls');
            const input = controls ? controls.querySelector('.quick-add-popup__qty-input') : null;
            if (input) {
                const currentVal = parseInt(input.value) || 1;
                input.value = currentVal + 1;
            }
            return;
        }

        // Check for quantity down button
        const qtyDownButton = e.target.closest('.quick-add-popup__qty-down');
        if (qtyDownButton) {
            e.preventDefault();
            const controls = qtyDownButton.closest('.quick-add-popup__qty-controls');
            const input = controls ? controls.querySelector('.quick-add-popup__qty-input') : null;
            if (input) {
                const currentVal = parseInt(input.value) || 1;
                if (currentVal > 1) {
                    input.value = currentVal - 1;
                }
            }
            return;
        }
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            document.querySelectorAll('.quick-add-popup[aria-hidden="false"], .quick-add-popup.is-open').forEach(function (popup) {
                popup.setAttribute('aria-hidden', 'true');
                popup.classList.remove('is-open');
                document.body.style.overflow = '';
            });
        }
    });

    // Close popup after successful add to cart - using event delegation
    document.addEventListener('submit', function (e) {
        const form = e.target.closest('.quick-add-popup__form-inner');
        if (form) {
            const popup = form.closest('.quick-add-popup');
            if (popup) {
                setTimeout(function () {
                    popup.setAttribute('aria-hidden', 'true');
                    popup.classList.remove('is-open');
                    document.body.style.overflow = '';
                }, 1500);
            }
        }
    });

    // Also initialize any existing elements on page load (for compatibility)
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    function init() {
        // Log for debugging
        console.log('Quick Add Popup JS initialized');

        // Count buttons
        const buttons = document.querySelectorAll('[data-quick-add-open]');
        console.log('Found ' + buttons.length + ' quick add buttons');
    }
})();
